module.exports = __webpack_public_path__ + "img/bg.7af551b5.png";